<template>
    <div>
        <comp-to-one @my-submit="date?getList(currentPage):''"/>

        <div class="common-header" style="margin-top: 20px">
            <h3>历史记录</h3>
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-select v-model="rechargeType">
                        <el-option
                                v-for="item of rechargeTypeOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-input v-model="searchVal" placeholder="请输入">
                        <template slot="prepend">渠道ID</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>
        <strong v-text="`充豆总量：${totalAbsRechargeChip} 金豆`"></strong>
        <div class="common-table">
            <el-table
                    :data="manualRechargePayChannelChipsList.beanList"
                    v-loading="loading"
                    height="100%"
                    row-key="id">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="渠道昵称" width="120" align="center" prop="payChannelName"/>
                <el-table-column label="渠道ID" width="120" align="center" prop="payChannelId"/>
                <el-table-column label="渠道金豆余额" min-width="120" align="center" prop="currentChip"/>
                <el-table-column label="渠道充豆后余额" min-width="120" align="center" prop="afterRechargeChip"/>
                <el-table-column label="充豆类型" min-width="150" align="center">
                    <template slot-scope="scope">{{scope.row.rechargeType | rechargeTypeName}}</template>
                </el-table-column>
                <el-table-column label="充豆状态" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.rechargeType === 1 || scope.row.rechargeType === 2 || scope.row.rechargeType === 8">
                            {{scope.row.rechargeStatus | rechargeStatusName}}
                            <i class="el-icon-edit-outline"
                               @click="rechargeStatusChange(scope.row)"></i>
                        </template>
                        <template v-else>/</template>
                    </template>
                </el-table-column>
                <el-table-column label="充豆数量" align="center" prop="rechargeChip"/>
                <el-table-column label="申请人" min-width="120" align="center" prop="applicant"/>
                <el-table-column label="审批人" min-width="120" align="center" prop="approver"/>
                <el-table-column label="操作账号" align="center" prop="operatorUsername"/>
                <el-table-column label="操作原因" min-width="180" align="center" show-overflow-tooltip prop="remark"/>
                <el-table-column label="操作时间" width="150" align="center" prop="createdTime"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="manualRechargePayChannelChipsList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>温馨提示</h3>
                <div class="common-popup-table" style="padding-bottom: 20px">
                    <p style="padding-bottom: 10px">修改{{clickRow.payChannelName}}的{{clickRow.rechargeType |
                        rechargeTypeName}}{{clickRow.rechargeChip}}金豆状态</p>
                    <el-select size="medium" v-model="rechargeStatus">
                        <el-option
                                v-for="item of rechargeStatusOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </div>
                <footer>
                    <el-button size="small" @click="show = false">取消</el-button>
                    <el-button type="primary" size="small" @click="submitFunc">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import compToOne from './compToOne'

    export default {
        components: {
            compToOne,
        },
        data() {
            return {
                show: false,
                loading: false,
                searchVal: '',
                date: null,
                currentPage: 1,
                rechargeType: '',
                rechargeTypeOptions: [
                    {label: '全部', value: ''},
                    {label: '手工收费', value: 1},
                    {label: '手工扣豆', value: 2},
                    {label: '赠送', value: 3},
                ],
                rechargeStatus: 1,// 要修改的充豆状态
                rechargeStatusOptions: [
                    {label: '已收', value: 1},
                    {label: '未收', value: 2},
                ],
                clickRow: null,// 修改点击的行
            }
        },
        computed: {
            ...mapState('manualRechargePayChannelChip', ['manualRechargePayChannelChipsList', 'totalAbsRechargeChip']),
        },
        filters: {
            // 充豆状态
            rechargeStatusName(type) {
                let arr = ['已收', '未收','已付','未付'];
                return arr[type - 1];
            },
            // 充豆类型
            rechargeTypeName(type) {
                let arr = ['手工收费', '手工扣豆', '赠送', '系统红包', '手工补单', '营销-牌桌金豆红包', 'BUG赔付', '手动提现'];
                return arr[type - 1];
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('manualRechargePayChannelChip', ['getManualRechargePayChannelChipsList', 'updateRechargeStatus']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                return true
            },
            getList(page = 1) {
                if (!this.parameterCalibration()) return;
                this.currentPage = page;
                this.loading = true;
                this.getManualRechargePayChannelChipsList({
                    page,
                    payChannelId: this.searchVal,
                    rechargeType: this.rechargeType,
                    startDate: this.date[0],
                    endDate: this.date[1],
                }).then(() => {
                    this.loading = false
                })
            },
            rechargeStatusChange(row) {
                this.clickRow = row;
                this.show = true;
            },
            submitFunc() {
                this.updateRechargeStatus({
                    rechargeChipId: this.clickRow.id,
                    rechargeStatus: this.rechargeStatus
                }).then(() => {
                    this.$message.success('修改成功');
                    this.show = false;
                    this.getList(this.currentPage);
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/manualRechargePayChannelChips/export',
                    info: [
                        {name: 'page', value: this.currentPage},
                        {name: 'size', value: 20},
                        {name: 'payChannelId', value: this.searchVal},
                        {name: 'rechargeType', value: this.rechargeType},
                        {name: 'startDate', value: this.date[0]},
                        {name: 'endDate', value: this.date[1]},
                    ]
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-icon-edit-outline {
        color: $theme-color;
        cursor: pointer;
    }
</style>